"use client";

import {
  GITHUB_READ_TOOLS,
  GITHUB_WRITE_TOOLS,
} from "@workspace/connectors/definitions";
import { lazy } from "react";
import { createMcpToolRegistry } from "../mcp-tool-registry";

const githubMcpToolView = lazy(() =>
  import("./tool-view").then(({ GithubMcpToolView }) => ({
    default: GithubMcpToolView,
  }))
);

/**
 * GitHub is an MCP + progressive-disclosure capability — its tool parts arrive
 * as `github_${mcpToolName}`. See `createMcpToolRegistry`.
 */
export const githubToolRegistry = createMcpToolRegistry({
  prefix: "github",
  readTools: GITHUB_READ_TOOLS,
  writeTools: GITHUB_WRITE_TOOLS,
  view: githubMcpToolView,
});
